module.exports = "# Ian and Sara Intro\n\nYouTube: ITAnQrAoiI4\n\n## Notes\nIntro to Esmeralda and Goober Opening Story (0:56).\n\n# Esmeralda and Goober Opening Story\n\nYouTube: j41AGvP85gI\n\n## Notes\nEsmeralda and Goober visit the landfill and come face to face with supervillain Trashella (4:07).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/12_esOpeningStory/level2_opening.md
// module id = 1836
// module chunks = 2